import BASE_URL from 'components/BaseUrl/apiConfig';
import React,{useState} from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import Swal from 'sweetalert2';



export default function Landing1() {






    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        fullName: '',
        contact: '',
        email: '',
        message: '',
    });


    const [validationMessage, setValidationMessage] = useState({
        fullName: '',
        contact: '',
        email: '',
        message: '',
    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setValidationMessage((prevError) => ({
            ...prevError,
            [name]: '',
        }));
    };





    const handleChange1 = (e) => {
        const { name, value } = e.target;
        const numericValue = value.replace(/[^0-9]/g, ''); // Keep only numeric values

        setFormData((prevData) => ({
            ...prevData,
            [name]: numericValue, // Use numericValue instead of value
        }));
        setValidationMessage((prevError) => ({
            ...prevError,
            [name]: '', // Assuming you clear the validation message for the corresponding field
        }));
    };



    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        if (formData.fullName.trim() === '') {
            newErrors.fullName = "Full name is the required.";
            isValid = false;
        }

        if (formData.email.trim() === '') {
            newErrors.email = "Email is required.";
            isValid = false
        }
        else if (!isValidEmail(formData.email)) {
            newErrors.email = 'Email address is not valid.';
            isValid = false;
        }

        if (formData.message.trim() === '') {
            newErrors.message = "Message is required."
            isValid = false;
        }

        if (formData.contact.trim() === '') {
            newErrors.contact = "Contact number is required."
            isValid = false;
        }
        setValidationMessage(newErrors);
        return isValid;
    }



    const isValidEmail = (email) => {
        // Use a regular expression for basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSendMassage = async () => {

        if (!validateForm()) {
            return;
        }
        setLoading(true);
        try {
            const response = await fetch(`${BASE_URL}/api/Users/ContactUs`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json' // Corrected content type header
                },
                body: JSON.stringify({
                    fullName: formData.fullName,
                    contactNumber: formData.contact,
                    email: formData.email,
                    message: formData.message
                }),
            });

            if (response.ok) {
                setLoading(false);
                const data = await response.json();

                setFormData({
                    fullName: '',
                    contact: '',
                    email: '',
                    message: '',
                });

                // Display SweetAlert success message
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Request sent successfully.',
                });
            } else {
                const errorData = await response.json();
                setLoading(false);
                // Handle Error Message
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: errorData.msg,
                });
            }
        } catch (error) {
            setLoading(false);
            // Handle Catch block
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message,
            });
        }


    }





    return (
        <div>

            {/* <!-- Spinner Start --> */}
            {/* <div id="spinner" className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <div className="spinner-border position-relative text-primary" style={{width:'6rem', height:'6rem'}} role="status"></div>
        <img className="position-absolute top-50 start-50 translate-middle" src="/assets/img/icons/icon-1.png" alt="Icon"/>
    </div> */}
            {/* <!-- Spinner End --> */}


            {/* <!-- Topbar Start --> */}
            <div className="container-fluid bg-dark p-0 wow fadeIn" data-wow-delay="0.1s">
                <div className="row gx-0 d-none d-lg-flex">
                    <div className="col-lg-7 px-5 text-start">
                        <div className="h-100 d-inline-flex align-items-center py-3 me-3">
                            <a className="text-body px-2" href="tel:+0123456789"><i className="fa fa-phone-alt text-primary me-2"></i>+91 9815-34-0123</a>
                            <a className="text-body px-2" href="mailto:info@example.com"><i className="fa fa-envelope-open text-primary me-2"></i>info@antheminfotech.com</a>
                        </div>
                    </div>
                    <div className="col-lg-5 px-5 text-end">
                        {/* <div className="h-100 d-inline-flex align-items-center py-3 me-2">
                            <a className="text-body px-2" href="">Terms</a>
                            <a className="text-body px-2" href="">Privacy</a>
                        </div> */}
                        <div className="h-100 d-inline-flex align-items-center">
                            <a className="btn btn-sm-square btn-outline-body me-1" href="https://www.facebook.com/AnthemInfotech" target='_blank'><i className="fab fa-facebook-f"></i></a>
                            <a className="btn btn-sm-square btn-outline-body me-1" href="https://twitter.com/antheminfotech" target='_blank' ><i className="fab fa-twitter"></i></a>
                            <a className="btn btn-sm-square btn-outline-body me-1" href="https://www.linkedin.com/authwall?trk=bf&trkInfo=AQG1Jti_W8XDFwAAAY9RncwYha1ye7X1Zq-cS8pl9ztUVnDGnfSlr-fnaF2x5RV7kb6groalDgCzH20Bl3ZC-aTsHje54MDDmqjfXh4ZmtoHQjgyoDma9g9eEkChFXVWGHK2iqg=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fanthem-infotech-pvt-ltd-" target='_blank'><i className="fab fa-linkedin-in"></i></a>
                            <a className="btn btn-sm-square btn-outline-body me-0" href="https://api.whatsapp.com/send/?phone=919815340123&text=Hi+Anthem+Team.&type=phone_number&app_absent=0" target='_blank'><i className="fab fa-whatsapp"></i></a>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Topbar End --> */}


            {/* <!-- Navbar Start --> */}
            {/* <nav className="navbar navbar-expand-lg bg-white navbar-light sticky-top py-lg-0 px-lg-5 wow fadeIn" data-wow-delay="0.1s">
        <a href="index.html" className="navbar-brand ms-4 ">
            <h1 className="text-primary m-0"><img  src="/assets/img/icons/icon-1.png" alt="Icon"/><span className='ml-3'>Arkitektur</span></h1>
        </a>
        <button type="button" className="navbar-toggler me-4" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
            <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarCollapse">
            
            <a href="" className="btn btn-primary  py-2 px-4 d-none d-lg-block">Appointment</a>
        </div>
    </nav> */}
            <nav className="navbar navbar-expand-lg bg-white navbar-light sticky-top py-lg-0 px-lg-5 wow fadeIn" data-wow-delay="0.1s">
                <a href="index.html" className="navbar-brand ms-4 ">
                    <h1 className="text-primary m-0"><img src={require("assets/img/essentials_small.png")} alt="Icon" style={{ width: '200px' }} /></h1>
                </a>
                <button type="button" className="navbar-toggler me-4" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarCollapse">
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item">
                            <Link to="/login" className="custnav btn btn-primary py-2 px-4 d-none d-lg-block">Login</Link>
                        </li>
                    </ul>
                </div>
            </nav>

            {/* <!-- Navbar End --> */}


            {/* <!-- Carousel Start --> */}
            <div className="container-fluid p-0 pb-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="owl-carousel header-carousel position-relative">
                    <div className="owl-carousel-item position-relative" data-dot="<img src='/assets/img/carousel-1.jpg'>">
                        <img className="img-fluid" src="/assets/img/carousel-1.jpg" alt="" />
                        <div className="owl-carousel-inner">
                            <div className="container">
                                <div className="row justify-content-start">
                                    <div className="col-10 col-lg-8">
                                        <h1 className="display-1 text-white animated slideInDown">Best Architecture And Interior Design Services</h1>
                                        <p className="fs-5 fw-medium text-white mb-4 pb-3">Vero elitr justo clita lorem. Ipsum dolor at sed stet sit diam no. Kasd rebum ipsum et diam justo clita et kasd rebum sea elitr.</p>
                                        <a href="" className="btn btn-primary py-3 px-5 animated slideInLeft">Read More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="owl-carousel-item position-relative" data-dot="<img src='/assets/img/carousel-2.jpg'>">
                        <img className="img-fluid" src="/assets/img/carousel-2.jpg" alt="" />
                        <div className="owl-carousel-inner">
                            <div className="container">
                                <div className="row justify-content-start">
                                    <div className="col-10 col-lg-8">
                                        <h1 className="display-1 text-white animated slideInDown">Best Architecture And Interior Design Services</h1>
                                        <p className="fs-5 fw-medium text-white mb-4 pb-3">Vero elitr justo clita lorem. Ipsum dolor at sed stet sit diam no. Kasd rebum ipsum et diam justo clita et kasd rebum sea elitr.</p>
                                        <a href="" className="btn btn-primary py-3 px-5 animated slideInLeft">Read More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="owl-carousel-item position-relative" data-dot="<img src='/assets/img/carousel-3.jpg'>">
                        <img className="img-fluid" src="/assets/img/carousel-3.jpg" alt="" />
                        <div className="owl-carousel-inner">
                            <div className="container">
                                <div className="row justify-content-start">
                                    <div className="col-10 col-lg-8">
                                        <h1 className="display-1 text-white animated slideInDown">Best Architecture And Interior Design Services</h1>
                                        <p className="fs-5 fw-medium text-white mb-4 pb-3">Vero elitr justo clita lorem. Ipsum dolor at sed stet sit diam no. Kasd rebum ipsum et diam justo clita et kasd rebum sea elitr.</p>
                                        <a href="" className="btn btn-primary py-3 px-5 animated slideInLeft">Read More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Carousel End --> */}


            {/* <!-- Facts Start --> */}
            <div className="container-xxl py-5">
                <div className="container pt-5">
                    <div className="row g-4">
                        <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="fact-item text-center bg-light h-100 p-5 pt-0">
                                <div className="fact-icon">
                                    <img src="/assets/img/icons/icon-2.png" alt="Icon" />
                                </div>
                                <h3 className="mb-3">Design Approach</h3>
                                <p className="mb-0">Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem sed diam stet diam sed stet.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="fact-item text-center bg-light h-100 p-5 pt-0">
                                <div className="fact-icon">
                                    <img src="/assets/img/icons/icon-3.png" alt="Icon" />
                                </div>
                                <h3 className="mb-3">Innovative Solutions</h3>
                                <p className="mb-0">Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem sed diam stet diam sed stet.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="fact-item text-center bg-light h-100 p-5 pt-0">
                                <div className="fact-icon">
                                    <img src="/assets/img/icons/icon-4.png" alt="Icon" />
                                </div>
                                <h3 className="mb-3">Project Management</h3>
                                <p className="mb-0">Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem sed diam stet diam sed stet.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Facts End --> */}


            {/* <!-- About Start --> */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
                            <div className="about-img">
                                <img className="img-fluid" src="/assets/img/about-1.jpg" alt="" />
                                <img className="img-fluid" src="/assets/img/about-2.jpg" alt="" />
                            </div>
                        </div>
                        <div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
                            <h4 className="section-title">About Us</h4>
                            <h1 className="display-5 mb-4">A Creative Architecture Agency For Your Dream Home</h1>
                            <p>Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit. Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit, sed stet lorem sit clita duo justo magna dolore erat amet</p>
                            <p className="mb-4">Stet no et lorem dolor et diam, amet duo ut dolore vero eos. No stet est diam rebum amet diam ipsum. Clita clita labore, dolor duo nonumy clita sit at, sed sit sanctus dolor eos.</p>
                            <div className="d-flex align-items-center mb-5">
                                <div className="d-flex flex-shrink-0 align-items-center justify-content-center border border-5 border-primary" style={{ width: '120px', height: '120px' }}>
                                    <h1 className="display-1 mb-n2" data-toggle="counter-up">25</h1>
                                </div>
                                <div className="ps-4">
                                    <h3>Years</h3>
                                    <h3>Working</h3>
                                    <h3 className="mb-0">Experience</h3>
                                </div>
                            </div>
                            <a className="btn btn-primary py-3 px-5" href="">Read More</a>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- About End --> */}


            {/* <!-- Service Start --> */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: '600px' }}>
                        <h4 className="section-title">Our Services</h4>
                        <h1 className="display-5 mb-4">We Focused On Modern Architecture And Interior Design</h1>
                    </div>
                    <div className="row g-4">
                        <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="service-item d-flex position-relative text-center h-100">
                                <img className="bg-img" src="/assets/img/service-1.jpg" alt="" />
                                <div className="service-text p-5">
                                    <img className="mb-4" src="/assets/img/icons/icon-5.png" alt="Icon" />
                                    <h3 className="mb-3">Architecture</h3>
                                    <p className="mb-4">Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem sed diam stet diam sed stet.</p>
                                    <a className="btn" href=""><i className="fa fa-plus text-primary me-3"></i>Read More</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item d-flex position-relative text-center h-100">
                                <img className="bg-img" src="/assets/img/service-2.jpg" alt="" />
                                <div className="service-text p-5">
                                    <img className="mb-4" src="/assets/img/icons/icon-6.png" alt="Icon" />
                                    <h3 className="mb-3">3D Animation</h3>
                                    <p className="mb-4">Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem sed diam stet diam sed stet.</p>
                                    <a className="btn" href=""><i className="fa fa-plus text-primary me-3"></i>Read More</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="service-item d-flex position-relative text-center h-100">
                                <img className="bg-img" src="/assets/img/service-3.jpg" alt="" />
                                <div className="service-text p-5">
                                    <img className="mb-4" src="/assets/img/icons/icon-7.png" alt="Icon" />
                                    <h3 className="mb-3">House Planning</h3>
                                    <p className="mb-4">Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem sed diam stet diam sed stet.</p>
                                    <a className="btn" href=""><i className="fa fa-plus text-primary me-3"></i>Read More</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="service-item d-flex position-relative text-center h-100">
                                <img className="bg-img" src="/assets/img/service-4.jpg" alt="" />
                                <div className="service-text p-5">
                                    <img className="mb-4" src="/assets/img/icons/icon-8.png" alt="Icon" />
                                    <h3 className="mb-3">Interior Design</h3>
                                    <p className="mb-4">Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem sed diam stet diam sed stet.</p>
                                    <a className="btn" href=""><i className="fa fa-plus text-primary me-3"></i>Read More</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item d-flex position-relative text-center h-100">
                                <img className="bg-img" src="/assets/img/service-5.jpg" alt="" />
                                <div className="service-text p-5">
                                    <img className="mb-4" src="/assets/img/icons/icon-9.png" alt="Icon" />
                                    <h3 className="mb-3">Renovation</h3>
                                    <p className="mb-4">Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem sed diam stet diam sed stet.</p>
                                    <a className="btn" href=""><i className="fa fa-plus text-primary me-3"></i>Read More</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="service-item d-flex position-relative text-center h-100">
                                <img className="bg-img" src="/assets/img/service-6.jpg" alt="" />
                                <div className="service-text p-5">
                                    <img className="mb-4" src="/assets/img/icons/icon-10.png" alt="Icon" />
                                    <h3 className="mb-3">Construction</h3>
                                    <p className="mb-4">Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem sed diam stet diam sed stet.</p>
                                    <a className="btn" href=""><i className="fa fa-plus text-primary me-3"></i>Read More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Service End --> */}


            {/* <!-- Feature Start --> */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                            <h4 className="section-title">Why Choose Us!</h4>
                            <h1 className="display-5 mb-4">Why You Should Trust Us? Learn More About Us!</h1>
                            <p className="mb-4">Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit. Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit, sed stet lorem sit clita duo justo magna dolore erat amet</p>
                            <div className="row g-4">
                                <div className="col-12">
                                    <div className="d-flex align-items-start">
                                        <img className="flex-shrink-0" src="/assets/img/icons/icon-2.png" alt="Icon" />
                                        <div className="ms-4">
                                            <h3>Design Approach</h3>
                                            <p className="mb-0">Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem sed diam stet diam sed stet.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="d-flex align-items-start">
                                        <img className="flex-shrink-0" src="/assets/img/icons/icon-3.png" alt="Icon" />
                                        <div className="ms-4">
                                            <h3>Innovative Solutions</h3>
                                            <p className="mb-0">Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem sed diam stet diam sed stet.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="d-flex align-items-start">
                                        <img className="flex-shrink-0" src="/assets/img/icons/icon-4.png" alt="Icon" />
                                        <div className="ms-4">
                                            <h3>Project Management</h3>
                                            <p className="mb-0">Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem sed diam stet diam sed stet.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="feature-img">
                                <img className="img-fluid" src="/assets/img/about-2.jpg" alt="" />
                                <img className="img-fluid" src="/assets/img/about-1.jpg" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Feature End --> */}


            {/* <!-- Project Start --> */}
            <div className="container-xxl project py-5">
                <div className="container">
                    <div className="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: '600px' }}>
                        <h4 className="section-title">Our Projects</h4>
                        <h1 className="display-5 mb-4">Visit Our Latest Projects And Our Innovative Works</h1>
                    </div>
                    <div className="row g-4 wow fadeInUp" data-wow-delay="0.3s">
                        <div className="col-lg-4">
                            <div className="nav nav-pills d-flex justify-content-between w-100 h-100 me-4">
                                <button className="nav-link w-100 d-flex align-items-center text-start p-4 mb-4 active" data-bs-toggle="pill" data-bs-target="#tab-pane-1" type="button">
                                    <h3 className="m-0">01. Modern Complex</h3>
                                </button>
                                <button className="nav-link w-100 d-flex align-items-center text-start p-4 mb-4" data-bs-toggle="pill" data-bs-target="#tab-pane-2" type="button">
                                    <h3 className="m-0">02. Royal Hotel</h3>
                                </button>
                                <button className="nav-link w-100 d-flex align-items-center text-start p-4 mb-4" data-bs-toggle="pill" data-bs-target="#tab-pane-3" type="button">
                                    <h3 className="m-0">03. Mexwel Buiding</h3>
                                </button>
                                <button className="nav-link w-100 d-flex align-items-center text-start p-4 mb-0" data-bs-toggle="pill" data-bs-target="#tab-pane-4" type="button">
                                    <h3 className="m-0">04. Shopping Complex</h3>
                                </button>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="tab-content w-100">
                                <div className="tab-pane fade show active" id="tab-pane-1">
                                    <div className="row g-4">
                                        <div className="col-md-6" style={{ minHeight: '350px' }}>
                                            <div className="position-relative h-100">
                                                <img className="position-absolute img-fluid w-100 h-100" src="/assets/img/project-1.jpg"
                                                    style={{ objectFit: 'cover' }} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <h1 className="mb-3">25 Years Of Experience In Architecture Industry</h1>
                                            <p className="mb-4">Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit. Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit, sed stet lorem sit clita duo justo magna dolore erat amet</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Design Approach</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Innovative Solutions</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Project Management</p>
                                            <a href="" className="btn btn-primary py-3 px-5 mt-3">Read More</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="tab-pane-2">
                                    <div className="row g-4">
                                        <div className="col-md-6" style={{ minHeight: '350px' }}>
                                            <div className="position-relative h-100">
                                                <img className="position-absolute img-fluid w-100 h-100" src="/assets/img/project-2.jpg"
                                                    style={{ objectFit: 'cover' }} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <h1 className="mb-3">25 Years Of Experience In Architecture Industry</h1>
                                            <p className="mb-4">Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit. Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit, sed stet lorem sit clita duo justo magna dolore erat amet</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Design Approach</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Innovative Solutions</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Project Management</p>
                                            <a href="" className="btn btn-primary py-3 px-5 mt-3">Read More</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="tab-pane-3">
                                    <div className="row g-4">
                                        <div className="col-md-6" style={{ minHeight: '350px' }}>
                                            <div className="position-relative h-100">
                                                <img className="position-absolute img-fluid w-100 h-100" src="/assets/img/project-3.jpg"
                                                    style={{ objectFit: 'cover' }} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <h1 className="mb-3">25 Years Of Experience In Architecture Industry</h1>
                                            <p className="mb-4">Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit. Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit, sed stet lorem sit clita duo justo magna dolore erat amet</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Design Approach</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Innovative Solutions</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Project Management</p>
                                            <a href="" className="btn btn-primary py-3 px-5 mt-3">Read More</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="tab-pane-4">
                                    <div className="row g-4">
                                        <div className="col-md-6" style={{ minHeight: '350px' }}>
                                            <div className="position-relative h-100">
                                                <img className="position-absolute img-fluid w-100 h-100" src="/assets/img/project-4.jpg"
                                                    style={{ objectFit: 'cover' }} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <h1 className="mb-3">25 Years Of Experience In Architecture Industry</h1>
                                            <p className="mb-4">Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit. Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit, sed stet lorem sit clita duo justo magna dolore erat amet</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Design Approach</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Innovative Solutions</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Project Management</p>
                                            <a href="" className="btn btn-primary py-3 px-5 mt-3">Read More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Project End --> */}


            {/* <!-- Team Start --> */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: '600px' }}>
                        <h4 className="section-title">Team Members</h4>
                        <h1 className="display-5 mb-4">We Are Creative Architecture Team For Your Dream Home</h1>
                    </div>
                    <div className="row g-0 team-items">
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="team-item position-relative">
                                <div className="position-relative">
                                    <img className="img-fluid" src="/assets/img/team-1.jpg" alt="" />
                                    <div className="team-social text-center">
                                        <a className="btn btn-square" href=""><i className="fab fa-facebook-f"></i></a>
                                        <a className="btn btn-square" href=""><i className="fab fa-twitter"></i></a>
                                        <a className="btn btn-square" href=""><i className="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                <div className="bg-light text-center p-4">
                                    <h3 className="mt-2">Architect Name</h3>
                                    <span className="text-primary">Designation</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="team-item position-relative">
                                <div className="position-relative">
                                    <img className="img-fluid" src="/assets/img/team-2.jpg" alt="" />
                                    <div className="team-social text-center">
                                        <a className="btn btn-square" href=""><i className="fab fa-facebook-f"></i></a>
                                        <a className="btn btn-square" href=""><i className="fab fa-twitter"></i></a>
                                        <a className="btn btn-square" href=""><i className="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                <div className="bg-light text-center p-4">
                                    <h3 className="mt-2">Architect Name</h3>
                                    <span className="text-primary">Designation</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="team-item position-relative">
                                <div className="position-relative">
                                    <img className="img-fluid" src="/assets/img/team-3.jpg" alt="" />
                                    <div className="team-social text-center">
                                        <a className="btn btn-square" href=""><i className="fab fa-facebook-f"></i></a>
                                        <a className="btn btn-square" href=""><i className="fab fa-twitter"></i></a>
                                        <a className="btn btn-square" href=""><i className="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                <div className="bg-light text-center p-4">
                                    <h3 className="mt-2">Architect Name</h3>
                                    <span className="text-primary">Designation</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
                            <div className="team-item position-relative">
                                <div className="position-relative">
                                    <img className="img-fluid" src="/assets/img/team-4.jpg" alt="" />
                                    <div className="team-social text-center">
                                        <a className="btn btn-square" href=""><i className="fab fa-facebook-f"></i></a>
                                        <a className="btn btn-square" href=""><i className="fab fa-twitter"></i></a>
                                        <a className="btn btn-square" href=""><i className="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                <div className="bg-light text-center p-4">
                                    <h3 className="mt-2">Architect Name</h3>
                                    <span className="text-primary">Designation</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Team End --> */}


            {/* <!-- Appointment Start --> */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                            <h4 className="section-title">Contact Us</h4>
                            <h1 className="display-5 mb-4">Make An Appointment To Start Your Dream Project</h1>
                            <p className="mb-4">Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit. Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit, sed stet lorem sit clita duo justo magna dolore erat amet</p>
                            <div className="row g-4">
                                <div className="col-12">
                                    <div className="d-flex">
                                        <div className="d-flex flex-shrink-0 align-items-center justify-content-center bg-light" style={{ width: '65px', height: '65px' }}>
                                            <i className="fa fa-2x fa-phone-alt text-primary"></i>
                                        </div>
                                        <div className="ms-4">
                                            <p className="mb-2">Call Us Now</p>
                                            <h3 className="mb-0">+91 9815-34-0123</h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="d-flex">
                                        <div className="d-flex flex-shrink-0 align-items-center justify-content-center bg-light" style={{ width: '65px', height: '65px' }}>
                                            <i className="fa fa-2x fa-envelope-open text-primary"></i>
                                        </div>
                                        <div className="ms-4">
                                            <p className="mb-2">Mail Us Now</p>
                                            <h3 className="mb-0">info@antheminfotech.com</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="row g-3">
                                <div className="col-12 col-sm-12">
                                    <input
                                        type="text"
                                        className="form-control"
                                        maxlength="30"
                                        id="fullName"
                                        name="fullName"
                                        onChange={handleChange}
                                        value={formData.fullName}
                                        placeholder="Your Full Name" style={{ height: '50px' }} />
                                </div>
                                <div className="col-12 col-sm-6">
                                    <input
                                        type="text"
                                        id="email"
                                        name="email"
                                        maxlength="50"
                                        onChange={handleChange}
                                        value={formData.email}
                                        className="form-control"
                                        placeholder="Your Email Address" style={{ height: '50px' }} />
                                </div>
                                <div className="col-12 col-sm-6">
                                    <input
                                        type="contact"
                                        id="contact"
                                        name="contact"
                                        maxlength="15"
                                        onChange={handleChange1}
                                        value={formData.contact}
                                        className="form-control"
                                        placeholder="Your Mobile" style={{ height: '50px' }} />
                                </div>

                                <div className="col-12">
                                    <textarea
                                        className="form-control"
                                        id="message"
                                        name="message"
                                        maxlength="300"  
                                        onChange={handleChange}
                                        value={formData.message}
                                        rows="5" placeholder="Message"></textarea>
                                </div>
                                <div className="col-12">
                                    <button className="btn btn-primary w-100 py-3" type="submit">Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Appointment End --> */}


            {/* <!-- Testimonial Start --> */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: '600px' }}>
                        <h4 className="section-title">Testimonial</h4>
                        <h1 className="display-5 mb-4">Thousands Of Customers Who Trust Us And Our Services</h1>
                    </div>
                    <div className="owl-carousel testimonial-carousel wow fadeInUp" data-wow-delay="0.1s">
                        <div className="testimonial-item text-center" data-dot="<img className='img-fluid' src='img/testimonial-1.jpg' alt=''>">
                            <p className="fs-5">Clita clita tempor justo dolor ipsum amet kasd amet duo justo duo duo labore sed sed. Magna ut diam sit et amet stet eos sed clita erat magna elitr erat sit sit erat at rebum justo sea clita.</p>
                            <h3>Client Name</h3>
                            <span className="text-primary">Profession</span>
                        </div>
                        <div className="testimonial-item text-center" data-dot="<img className='img-fluid' src='img/testimonial-2.jpg' alt=''>">
                            <p className="fs-5">Clita clita tempor justo dolor ipsum amet kasd amet duo justo duo duo labore sed sed. Magna ut diam sit et amet stet eos sed clita erat magna elitr erat sit sit erat at rebum justo sea clita.</p>
                            <h3>Client Name</h3>
                            <span className="text-primary">Profession</span>
                        </div>
                        <div className="testimonial-item text-center" data-dot="<img className='img-fluid' src='img/testimonial-3.jpg' alt=''>">
                            <p className="fs-5">Clita clita tempor justo dolor ipsum amet kasd amet duo justo duo duo labore sed sed. Magna ut diam sit et amet stet eos sed clita erat magna elitr erat sit sit erat at rebum justo sea clita.</p>
                            <h3>Client Name</h3>
                            <span className="text-primary">Profession</span>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Testimonial End --> */}


            {/* <!-- Footer Start --> */}
            <div className="container-fluid bg-dark text-body footer mt-5 pt-5 px-0 wow fadeIn" data-wow-delay="0.1s">
                {/* <div className="container py-5">
                    <div className="row g-5">
                        <div className="col-lg-3 col-md-6">
                            <h3 className="text-light mb-4">Address</h3>
                            <p className="mb-2"><i className="fa fa-map-marker-alt text-primary me-3"></i>123 Street, New York, USA</p>
                            <p className="mb-2"><i className="fa fa-phone-alt text-primary me-3"></i>+012 345 67890</p>
                            <p className="mb-2"><i className="fa fa-envelope text-primary me-3"></i>info@example.com</p>
                            <div className="d-flex pt-2">
                                <a className="btn btn-square btn-outline-body me-1" href=""><i className="fab fa-twitter"></i></a>
                                <a className="btn btn-square btn-outline-body me-1" href=""><i className="fab fa-facebook-f"></i></a>
                                <a className="btn btn-square btn-outline-body me-1" href=""><i className="fab fa-youtube"></i></a>
                                <a className="btn btn-square btn-outline-body me-0" href=""><i className="fab fa-linkedin-in"></i></a>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <h3 className="text-light mb-4">Services</h3>
                            <a className="btn btn-link" href="">Architecture</a>
                            <a className="btn btn-link" href="">3D Animation</a>
                            <a className="btn btn-link" href="">House Planning</a>
                            <a className="btn btn-link" href="">Interior Design</a>
                            <a className="btn btn-link" href="">Construction</a>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <h3 className="text-light mb-4">Quick Links</h3>
                            <a className="btn btn-link" href="">About Us</a>
                            <a className="btn btn-link" href="">Contact Us</a>
                            <a className="btn btn-link" href="">Our Services</a>
                            <a className="btn btn-link" href="">Terms & Condition</a>
                            <a className="btn btn-link" href="">Support</a>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <h3 className="text-light mb-4">Newsletter</h3>
                            <p>Dolor amet sit justo amet elitr clita ipsum elitr est.</p>
                            <div className="position-relative mx-auto" style={{ maxWidth: '400px' }}>
                                <input className="form-control bg-transparent w-100 py-3 ps-4 pe-5" type="text" placeholder="Your email" />
                                <button type="button" className="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2">SignUp</button>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className="container-fluid copyright">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                                Copyright © {new Date().getFullYear()}{" "}

                                Anthem Infotech Private Limited. All rights reserved.
                            </div>
                            <div className="col-md-6 text-center text-md-end">
                                <span className="mr-2 mt-1">Powered by </span><span className="custom-footer">
                                    <Link
                                        href="https://antheminfotech.com/"
                                        className="text-white-900 hover:text-white-700 text-sm font-semibold py-1"
                                        target="_blank"
                                        style={{ color: 'white' }}
                                    >
                                        Anthem Infotech Pvt. Ltd.
                                    </Link>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Footer End --> */}


            {/* <!-- Back to Top --> */}
            <a href="#" className="btn btn-lg btn-primary btn-lg-square back-to-top"><i className="bi bi-arrow-up"></i></a>



        </div>
    )
}
